import makeStyles from "@mui/styles/makeStyles";

export const useIconButtonStyles = makeStyles((theme) => ({
  root: {
    width: 40,
    height: 40,
    color: theme.palette.grey[700],
    "&[aria-disabled=true]": {
      opacity: 0.4,
      cursor: "default",
    },
  },
  colorPrimary: {
    color: theme.palette.primary.main,
  },
}));

export const useStyles = makeStyles(() => ({
  "@keyframes spin": {
    "0%": {
      transform: "rotate(-360deg)",
    },
    "100%": {
      transform: "rotate(0deg)",
    },
  },
  rotate: {
    position: "relative",
    animation: "$spin 600ms linear infinite",
  },
  sizeSmall: {
    width: 24,
    height: 24,
  },
  sizeTiny: {
    width: 20,
    height: 20,
    padding: 0,
    "& svg": {
      width: 20,
      height: 20,
    },
  },
}));
